import * as Loadable from 'react-loadable';
import { LoadingComponent } from 'library/loader/LoadingComponent';

export function LoadableComponent<Props>(opts: { loader: () => Promise<React.ComponentType<Props>> }) : React.ComponentType<Props> {
  return Loadable(Object.assign({
    loading: LoadingComponent,
    delay: 200,
    timeout: 10
  }, opts as any));
};